// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterForm__hgroup":"oh_a bhk_a bhk_x","FilterForm__vgroup":"oh_b bhk_st"};